module.exports = __webpack_public_path__ + "img/armhole length back.5cc68579.png";